import {
  AppBar,
  Breadcrumbs,
  Divider,
  IconButton,
  ListItem,
  MenuItem,
  Popover,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { ArrowRight, Search } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import { get } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addDays, format } from 'date-fns';
import restApi from '../../api/restApi';
import { finishAccountSwitch, switchAccountWithContentIndexReset } from '../content-index-manager/utils/accountSwitch';
import QLogo from '../../assets/images/quattr_logo_white.png';
import { QwaUser } from '../../auth/types';
import { actionTypes } from '../../constants/actionTypes';
import { SUBSCRIPTION_STATUS } from '../../constants/common';
import { CUSTOM_RANGE } from '../../constants/formMeta/growthTrends';
import { resolveTopTrendPickerSelection } from '../../utility/services/savedTrendReopen';
import { SidebarNav, sideBarNavs } from '../../constants/navigationMeta';
import {
  appendHttpsIfNotPresent,
  getAvatarInitials,
  getLogo,
  processSubscriptionData,
  RemoveLastUrlPartOf,
  USER_CLASSIFICATION,
} from '../../utility/common';
import { signOut } from '../../utility/services/authActions';
import { useQalert } from '../../utility/services/customHooks';
import {
  useIsInternalUser,
  useIsSubscriberUser,
  useIsTestDriveUser,
  useSchema,
  useSession,
  useTestDriveDomain,
} from '../../utility/services/customHooks/auth';
import Utility from '../../utility/services/utility';
import { DateRangePicker, FormDropDown } from '../formElements';
import CollapsibleListItem from '../formElements/src/CollapsibleListItem';

import { excludeCustomerList, excludeNavigateURLList } from '../../constants/navigationMeta';
import { useRollbar } from '@rollbar/react';
import { setAmplitudeInstance, segmentEventApi } from '../../constants/analyticsMeta';
import ManageSubscriptions from '../shared/quattr-actions/components/ManageSubscriptions';
import { toTitleCase } from '../../utility/common';
import CreditsComponent from './CreditsComponent';
import PageDateRangeSlot, { usePageDateRangeHost } from './PageDateRangeSlot';
import IfComponent from '../shared/IfComponent';
import { Skeleton } from '@material-ui/lab';
const breadcrumbMeta = {
  'all-boards': 'All Boards',
  'my-analysis': 'My Analysis',
  favorites: 'Favorites',
};

// AUTH0_TODO optimize useEffects
export default function Header(props) {
  const { isEnterpriseUser, userType } = props;
  const [defaultUser, setDefaultUser] = React.useState(props.defaultUser || USER_CLASSIFICATION.QWA_TOOLS);
  const [anchorEl2, setAnchorEl2] = React.useState<Element | null>(null);
  const [userName, setUserName] = React.useState('');
  const router = useRouter();
  const dispatch = useDispatch();
  const exploresArray = useSelector((state) => state.root.explores);
  const looksList = useSelector((state) => state.root.looksList);
  const dashboardsList = useSelector((state) => state.root.dashboardsList);
  const adHocAnalysisFolders = useSelector((state) => state.root.adHocAnalysisFolders || []);
  const customerInfo = useSelector((state) => state.root.customerInfo || []);
  const schemaName = useSchema();
  const customerData = customerInfo.find((o) => o.cust_code === schemaName);
  const [accountsList, setAccountList] = React.useState<any[]>([]);
  const [searchAccount, setSearchAccount] = React.useState('');
  const [showCustomerInfo, setShowCustomerInfo] = React.useState(false);
  const [subscriberMeta, setSubscriberMeta] = React.useState<any>({});
  const [redirected, setRedirected] = React.useState(false);
  const { pathname } = router;
  const { session, authState } = useSession();
  let qwaUser: QwaUser | undefined = undefined;
  let schemaList: string[] = [];

  if (session?.user) {
    qwaUser = session.user;
    schemaList = qwaUser.groups || [];
  }
  const isTestDriveUser = useIsTestDriveUser();
  const testDriveDomain = useTestDriveDomain();

  const [schemaIndex, setSchemaIndex] = React.useState(-1);
  const [hasCrListCalledAPI, setHasCrListCalledAPI] = React.useState(false);

  const rollbar = useRollbar();
  const filter = useSelector((state) => state.root.datePickerFilter);
  const paths = [
    '/app/trends/competitive-trends/[id]',
    '/app/trends/growth-trends/[id]',
    '/app/trends/competitive-trends',
    '/app/trends/growth-trends',
    'app/ranking-factors',
    '/app/trends/ai-visibility',
    '/app/trends/ai-visibility/',
  ];
  const showGlobalDatePicker = (paths, pathName) => paths.some((path) => pathName.includes(path));
  const showDatePicker = showGlobalDatePicker(paths, router.pathname);
  // The date range selector is still created here, so its state survives moving between the
  // screens above, but it is shown on each screen itself, at the start of its filter row: it
  // renders into one shared node that the screen's PageDateRangeSlot picks up. A screen with no
  // header card of its own keeps the selector in the top bar. The Ranking Factors search screen
  // shows none: nothing on it uses the dates, and its results always start at the last 90 days.
  const topBarDatePickerPaths = ['/app/trends/ai-visibility-dashboard'];
  const isDatePickerInTopBar = showGlobalDatePicker(topBarDatePickerPaths, router.pathname);
  const dateRangeHost = usePageDateRangeHost();
  // AI Visibility applies its own rolling default ('Last 90 Days'); seed the picker's Date Range
  // dropdown from that selection so its label matches the header instead of falling back to the
  // picker's hardcoded 'Last 12 Complete Weeks' default.
  const isAiVisibilityRoute = router.pathname.includes('/app/trends/ai-visibility');
  const [, toggleSnackBar] = useQalert();
  const [userSelectedDateRange, setUserSelectedDateRange] = React.useState();
  const lastShowDatePickerRef = React.useRef(filter?.filters?.is_date_comparison == 'Yes');
  const dateRangekey =
    String(filter.isTopTrendDetails) +
    String(filter.isSiteDetail) +
    String(filter.isUsabilityRecommendaton) +
    String(filter.isRankingFactor);

  const handleDrawerOpen = () => {
    props.toggleDrawer(!props.open);
  };

  const handleDropDownclickSchema = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleLogout = async () => {
    /**
     * https://next-auth.js.org/getting-started/client#using-the-redirect-false-option-1
     */
    // will redirect to homepage via NextJS's router);
    const signOutPromise = signOut();
    if (window.analytics) {
      window.analytics.track('Logout');
    } else {
      segmentEventApi('Logout', null, 'track');
    }
    return await signOutPromise;
  };

  const showCustomerInformation = useCallback(
    (customerInfo) => {
      let tempCustList: { title: string; cust_name: string }[] = [];

      // consider only customers whose schema (cust_code) is present in schemaList
      const childCustomers = customerInfo.filter((i) => i.cust_child_name && schemaList.includes(i.cust_code));

      customerInfo.forEach((cust) => {
        // skip customers whose schema (cust_code) is not present in schemaList
        if (!schemaList.includes(cust.cust_code)) {
          return;
        }

        if (!tempCustList.find((i) => i.title == cust.cust_name) && !cust.cust_child_name) {
          // customer is not already added and should not be the child
          if (childCustomers.find((i) => i.cust_name == cust.cust_name)) {
            // check if customer has a child
            const obj = {
              title: cust.cust_name,
              listItems: childCustomers.filter((i) => i.cust_name == cust.cust_name),
              ...cust,
            };
            tempCustList.push(obj);
          } else {
            tempCustList.push(cust);
          }
        }
      });
      tempCustList = tempCustList.sort((a, b) => {
        let fa = a.cust_name.toLowerCase(),
          fb = b.cust_name.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });
      setAccountList(tempCustList);

      setShowCustomerInfo(true);
    },
    [schemaList]
  );

  const setAmplitudeSegmentEvents = async (payload) => {
    if (window.analytics) {
      window.analytics.identify(payload?.email, {
        email: payload.email,
        name: payload.email,
        schema: payload.schema,
        instance_type: payload.instance_type,
        user_type: payload.user_type,
        company_name: payload.company_name,
      });
      setAmplitudeInstance(payload.email);
    }
  };

  const openSchema = Boolean(anchorEl2);

  // customer-info is fetched once by usePreFetchData() in PrivateLayout.
  // Header is a pure consumer of the Redux state — it does NOT trigger the API.
  useEffect(() => {
    if (session === undefined || !customerInfo?.length) {
      return;
    }
    const index = customerInfo.findIndex((data) => data.cust_code == schemaName);
    setSchemaIndex(index == -1 ? 0 : index);
    showCustomerInformation(customerInfo);
  }, [customerInfo, schemaName, session, showCustomerInformation]);

  const isInternal = useIsInternalUser();
  const isSubscriber = useIsSubscriberUser();
  React.useEffect(() => {
    // TODO_AUTH0 fix error loop
    // console.log('in useEffect 2');
    // we don't want analytics to crash the entire session, so try/catch
    try {
      if (customerInfo && qwaUser?.email && customerInfo.length && window.analytics) {
        const index = customerInfo.findIndex((data) => {
          return data.cust_code === schemaName;
        });
        const schemaInfo = customerInfo[index];
        const isContentAIUser =
          schemaInfo?.sidebar_link_config && schemaInfo?.sidebar_link_config['is-content-enabled-only'];
        const instance_type = schemaInfo?.additional_user_info?.isDemoUser
          ? 'Sandbox'
          : isSubscriber
          ? 'Test Drive'
          : isContentAIUser
          ? 'Content AI'
          : 'Full Tenant';
        const user_type =
          isContentAIUser && !isInternal
            ? 'Free Trial'
            : isSubscriber && !isInternal
            ? 'Prospect'
            : isInternal
            ? 'Internal'
            : 'Customer';
        const user_email = qwaUser.email;
        const companyName = isSubscriber ? qwaUser?.name : schemaInfo?.cust_name;
        const payload = {
          email: user_email,
          name: user_email,
          schema: schemaInfo?.cust_code,
          instance_type: instance_type,
          user_type: user_type,
          company_name: companyName,
        };
        //set identify event at amplitude and segment based on windows analaytics
        setAmplitudeSegmentEvents(payload);
      }
    } catch (error) {
      rollbar.error(`Header: Analytics failed to save`, { error });
    }
  }, [customerInfo, isInternal, isSubscriber, qwaUser?.email, qwaUser?.name, rollbar, schemaName]);

  useEffect(() => {
    // TODO_AUTH0 fix error loop
    // console.log('in useEffect 3');
    if (isTestDriveUser && testDriveDomain) {
      setUserName(testDriveDomain);
    } else if (qwaUser?.name) {
      if (qwaUser.subscription_status) {
        // purposefully logged
        console.log('qwaUser.subscription_status => ', qwaUser.subscription_status);
      }
      setUserName(qwaUser?.name);
    }
  }, [isTestDriveUser, qwaUser, testDriveDomain]);

  //TO BE ADDED LATER
  // useEffect(() => {
  //   const fetchCRData = async () => {
  //     console.log('Calling header fetchCRData');
  //     console.log('Calling header fetchCRData hasCrListCalledAPI', schemaName, hasCrListCalledAPI);
  //     if (schemaName && !hasCrListCalledAPI) {
  //       const forceRefetch = true;
  //       const filterPayload = {
  //         filtersObj: {},
  //         limit: 20000,
  //         isPagination: true,
  //         dataSource: 'organic',
  //         resetCache: true,
  //       };

  //       try {
  //         // Dispatch the query without waiting
  //         dispatchCRListDataQuery(dispatch, filterPayload, forceRefetch)
  //           .then((response) => {
  //             console.log('Calling header fetchCRData got response');
  //             // Store data in IndexedDB asynchronously
  //             const sortedData = mapPaidAndOrgData(removeViewNameFromChartsData(response?.data?.crPagesList));
  //             localStorage.setItem(`content-recommendations-list-cachedAt${schemaName}`, response?.data?.cachedAt);
  //             fetchAndStoreCRData(sortedData, schemaName)
  //               .then(() => {
  //                 console.log('Calling header fetchCRData got response and fetchAndStoreCRData');
  //                 // Update the state to indicate API call has been made
  //                 setHasCrListCalledAPI(true);
  //               })
  //               .catch((error: any) => {
  //                 console.error('Failed to store data in IndexedDB', error);
  //               });
  //           })
  //           .catch((error) => {
  //             console.error('Failed to fetch data', error);
  //           });
  //       } catch (error) {
  //         console.error('Error while fetching and storing data', error);
  //       }
  //     }
  //   };

  //   // Call the async function
  //   fetchCRData();
  // }, [schemaName, hasCrListCalledAPI, session, dispatch, setHasCrListCalledAPI]);

  useEffect(() => {
    if (customerData && customerData.SubscriberUserDetails) {
      const _subscriberMeta = processSubscriptionData(customerData);
      setSubscriberMeta(_subscriberMeta);
      if (_subscriberMeta && _subscriberMeta.isInTrial) {
        dispatch({
          type: actionTypes?.SET_SHOW_SUBSCRIPTION_BANNER,
          showSubscriberBanner: _subscriberMeta?.customer_id,
        });

        dispatch({
          type: actionTypes?.SET_SUBSCRIBER_META,
          subscriberMeta: _subscriberMeta,
        });
      }
    }
  }, [customerData, dispatch]);

  const updateDatePickerParams = (params, showDatePicker) => {
    lastShowDatePickerRef.current = showDatePicker;
    //set user selected date range in store to trigger filter method and call looker API
    dispatch({
      type: actionTypes.SET_USER_SELECTED_DATE_RANGE,
      userSelectedDateRange: { params: params, showDatePicker: showDatePicker },
    });
  };

  const updateDateRange = (params) => {
    dispatch({
      type: actionTypes.SET_DEFAULT_DATE_RANGE,
      defaultDateRange: params,
    });
  };

  const showPeriodDoesNotMatchWarning = (selectedDateObj, comparisonDateObj) => {
    const { is_date_comparison, date_granularity } = filter.filters;

    if (is_date_comparison == 'Yes') {
      let selectionPeriodCount = 0,
        comparisonPeriodCount = 0;

      selectionPeriodCount = Utility.getDiffAsPerGranularityType(
        date_granularity,
        selectedDateObj.startDate,
        selectedDateObj.endDate
      );
      comparisonPeriodCount = Utility.getDiffAsPerGranularityType(
        date_granularity,
        comparisonDateObj.startDate,
        comparisonDateObj.endDate
      );

      if (selectionPeriodCount != comparisonPeriodCount) {
        toggleSnackBar({
          type: 'warning',
          open: true,
          text: `Number of ${date_granularity} in selected and comparison periods do not match`,
        });
      }
    }
  };

  const setDateRanges = (dateRanges) => {
    const selectedPeriod = `${format(dateRanges.selected.startDate, 'yyyy/MM/dd')} to ${format(
      addDays(dateRanges.selected.endDate, 1),
      'yyyy/MM/dd'
    )}`;

    setUserSelectedDateRange(dateRanges);
    showPeriodDoesNotMatchWarning(dateRanges.selected, dateRanges.comparison);
    updateDateRange(dateRanges);
    dispatch({
      type: actionTypes.SET_GLOBAL_DATE_RANGE_FILTERS,
      filtersData: {
        ...filter,
        filters: {
          ...(filter?.filters || {}),
          selected_period: selectedPeriod,
          is_date_comparison: lastShowDatePickerRef.current ? 'Yes' : 'No',
        },
        dateRanges,
        isPersisitedFilters: true,
      },
    });
  };

  const containsDynamicRoute = pathname.includes('[name]') || pathname.includes('[id]');
  const showBreadCrumb =
    pathname.includes('/app/adhoc-analysis/') &&
    (pathname.includes('/explore/') || pathname.includes('/look/') || pathname.includes('/dashboard/'));
  let dynamicRouteTitle = '';

  if (pathname.includes('[name]') && exploresArray.length) {
    const lookData = exploresArray.find((i) => i.name == router.query.name);
    dynamicRouteTitle = lookData ? lookData.label : '';
  } else if (pathname.includes('/dashboard/[id]')) {
    const fromMine = (dashboardsList || []).find((i) => i.id == router.query.id);
    const fromFolders = (adHocAnalysisFolders || [])
      .flatMap((folder) => folder.dashboards || [])
      .find((dashboard) => dashboard.id == router.query.id);
    dynamicRouteTitle = (fromMine || fromFolders)?.title || '';
  } else if (pathname.includes('[id]')) {
    const fromMine = (looksList || []).find((i) => i.id == router.query.id);
    const fromFolders = (adHocAnalysisFolders || [])
      .flatMap((folder) => folder.looks || [])
      .find((look) => look.id == router.query.id);
    dynamicRouteTitle = (fromMine || fromFolders)?.title || '';
  }

  let allNavs: SidebarNav[] = [];
  sideBarNavs.forEach((i) => {
    allNavs = [...allNavs, ...(i.subNavs || [])];
  });
  let matchUrl = containsDynamicRoute ? RemoveLastUrlPartOf(router.pathname, 2) : router.pathname;
  let currentNav = allNavs.find((i) => i.to === matchUrl);
  if (!currentNav) {
    matchUrl = containsDynamicRoute ? RemoveLastUrlPartOf(router.pathname, 1) : router.pathname;
    currentNav = allNavs.find((i) => i.to === matchUrl);
  }

  useEffect(() => {
    // TODO_AUTH0 fix unending error loop due to useEffects and useCallbacks
    // need these logs to track the sequence
    // console.log('in useEffect 4');
    if (!redirected) {
      const sideBarConfigHeader = customerInfo[schemaIndex]?.sidebar_link_config;
      //for ai tools users
      if (sideBarConfigHeader == undefined && props?.getUserType === USER_CLASSIFICATION.QWA_TOOLS) {
        const redirectUrl = '/app/ai-tools-home';
        if (
          ![
            '/app/ai-tools-home',
            '/app/content-ai-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits',
          ].includes(router.pathname)
        ) {
          setRedirected(true);
          router?.push(redirectUrl);
        }
      } else if (sideBarConfigHeader !== undefined) {
        const routeLinks = sideBarNavs?.flatMap((item) =>
          item.subNavs
            ?.filter((subNav) => sideBarConfigHeader[subNav?.uniqueKey as keyof typeof sideBarConfigHeader])
            .map((subNav) => subNav.to)
        );
        // Whether the sidebar nav has actually resolved (before the exception safelist below is
        // pushed). If it hasn't, redirecting to routeLinks[0] would cancel an in-flight route change
        // (e.g. the Add-Tracker nav to /app/settings/setup/ai-visibility-trackers): the URL updates
        // but the view never mounts until a manual reload. See #35.
        const hasNavDerivedLinks = (routeLinks?.filter(Boolean)?.length ?? 0) > 0;

        //for non content ai customers
        if (!sideBarConfigHeader['is-content-enabled-only']) {
          // exceptional page scenario where page is not in nav list
          routeLinks.push(
            '/app/manage-queries/query-classification-rules',
            '/app/spike',
            '/app/manage-categories/classify-pages',
            '/app/manage-categories/taxonomy-designer',
            '/app/ai-tools-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits',
            '/app/settings/setup',
            // Team Members is unlocked in DropDownNav rather than through each
            // customer's sidebar_link_config, so it is absent from routeLinks
            // and needs the same safelist entry as the other settings pages.
            '/app/settings/team-members',
            '/app/settings/admin/schema',
            // Content Index is an internal-only page (gated to @quattr.com
            // in SideBar.tsx via the isInternal flag), so it's not in any
            // customer's sidebar_link_config — without this safelist entry,
            // Header's auto-redirect useEffect (line 491-507) bounces users
            // away from /app/content-index to routeLinks[0] = growth-trends
            // every time the page mounts. Listing it here keeps the
            // sidebar-visibility gate intact while letting direct URL
            // navigation work.
            '/app/content-index',
            // Same reasoning for the ASO Suite home. It is not in any customer's
            // sidebar_link_config, so without this entry an AI SEO Suite /
            // enterprise user who opens it is redirected straight back to
            // routeLinks[0] (growth trends). Whether this page becomes their
            // landing page is still an open product decision — this only makes
            // the route reachable, it does not put it in the nav.
            '/app/content-ai-home-2'
          );
        }
        //for content ai customers
        if (sideBarConfigHeader['is-content-enabled-only']) {
          // exceptional page scenario where page is not in nav list
          routeLinks.push(
            '/app/content-ai-home',
            // The ASO Suite home. It is not in any sidebar_link_config nav list,
            // so without this entry the auto-redirect below bounces users back to
            // routeLinks[0] the moment the page mounts. It happens to survive
            // today only because the containsSimilar check is a substring match
            // and '/app/content-ai-home' is a prefix of it — listing it
            // explicitly means a future rename cannot silently break the route.
            '/app/content-ai-home-2',
            '/app/ai-seo-suite-home',
            '/app/ai-tools-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits',
            // Same reasoning as the non-Content-AI branch above: contentAiNavConfig
            // shows this link and DropDownNav unlocks it regardless of
            // sidebar_link_config, where settings-team-members defaults to false.
            // So it never reaches routeLinks on its own, and without this entry the
            // redirect below bounces a Content AI customer off the page the moment
            // they click it — visible in the sidebar, impossible to open.
            '/app/settings/team-members'
          );
        }

        // AI Visibility Trackers lives under /app/settings/setup but is in no sidebar nav. The
        // non-content branch safelists the /app/settings/setup prefix, but the content-only branch
        // does not, and the substring spare also drops out during nav-config load. Push the exact
        // route unconditionally so the Add-Tracker navigation is never bounced to routeLinks[0]. (#35)
        routeLinks.push('/app/settings/setup/ai-visibility-trackers');

        // Market Share Trackers lives under /app/settings/setup but is in no sidebar nav, exactly like
        // the AI Visibility Trackers route above. Without this entry the redirect below bounces the user
        // to routeLinks[0], leaving the page visible in setup and impossible to open.
        routeLinks.push('/app/settings/setup/market-share-trackers');

        // Admin > Credits & Limits. Internal-only, so like Admin > Tenants it is in no customer's
        // sidebar_link_config and never reaches routeLinks on its own. Pushed UNCONDITIONALLY rather
        // than into the non-Content-AI branch beside '/app/settings/admin/schema': an internal admin
        // works across tenants of every type, and a Content-AI-only tenant would otherwise bounce them
        // off a page their sidebar is still showing. No other route contains this path, so the
        // containsSimilar substring test it feeds can only ever match this page.
        routeLinks.push('/app/settings/admin/credits-and-limits');

        if (!redirected && routeLinks && typeof window !== undefined) {
          const shouldRedirect = routeLinks !== undefined ? true : false;
          const targetURL =
            routeLinks[0] === '/app/manage-lists/keywords-list' ? '/app/content-ai-home' : routeLinks[0];
          // const targetURL = sideBarConfigHeader?.['is-content-enabled-only'] ? '/app/content-ai-home' : '/app/trends/growth-trends';
          const baserouterLinks = routeLinks?.filter(Boolean)?.map((url) => url?.split('?')[0]) ?? [];
          // Never bounce a legitimate AI Visibility route. This redirect guard's one-shot `redirected`
          // flag can stay ARMED here (the #35 hasNavDerivedLinks gate suppresses the harmless early-boot
          // fire that used to disarm it), so a transient render where the derived sidebar nav briefly
          // lacks the AIV link would otherwise fire router.push(targetURL) mid-transition and CANCEL the
          // dashboard -> /app/trends/ai-visibility/[platform] navigation (the "card click updates the URL
          // but the page does not change" bug). Treating any AIV route as already-safelisted stops that.
          const containsSimilar =
            router?.pathname?.startsWith('/app/trends/ai-visibility') ||
            baserouterLinks?.some((link) => router?.pathname?.includes(link ?? ''));
          // redirect to target url if paid content recommendation page for content ai customer only
          const isPaidRecommendation = router?.query?.type === 'paid' && sideBarConfigHeader['is-content-enabled-only'];
          if (shouldRedirect && targetURL && hasNavDerivedLinks) {
            if (router?.pathname !== targetURL) {
              if (!containsSimilar || isPaidRecommendation) {
                router?.push(targetURL);
                setRedirected(true); // Set the state to prevent further redirections
              }
            }
          }
        }
      }
    }
  }, [allNavs, customerInfo, redirected, router, router?.pathname, schemaIndex]);

  //redirect to the oragnic recomemndation for specific customer once loggedin
  if (schemaName && excludeCustomerList?.includes(schemaName) && !excludeNavigateURLList?.includes(router?.pathname)) {
    window.location?.replace('/app/content-recommendations?type=organic');
  }

  const changeSchema = useCallback(
    async (nextSchema) => {
      try {
        dispatch({
          type: actionTypes.ADD_LOADER,
          loaderName: 'PAGE_LOADER',
        });
        setAnchorEl2(null);
        const updateSchemaPayload = {
          selected_schema: nextSchema,
        };
        const contentIndexFallback = await switchAccountWithContentIndexReset(
          () => restApi.post(`/switch_account`, updateSchemaPayload),
          !schemaName || schemaName !== nextSchema,
          window.location.href,
          localStorage,
          window.history,
          sessionStorage
        );
        finishAccountSwitch(
          () => {
            localStorage.removeItem('contentrecommendation-listpage-filters');
            sessionStorage.removeItem('contentrecommendation-listpage-filters');
            localStorage.removeItem('content-recommendations-urls');
            Object.keys(localStorage).forEach(
              (key) => key.includes('reprocessModalSkipped') && localStorage.removeItem(key)
            );
            localStorage.setItem('switched_account', Date.now().toString());
          },
          () => {
            if (contentIndexFallback) {
              window.location.replace(contentIndexFallback);
            } else {
              window.location.reload();
            }
          }
        );
      } catch (error) {
        console.error('Header :: changeSchema: unable to update Looker schema');
      } finally {
        dispatch({
          type: actionTypes.REMOVE_LOADER,
          loaderName: 'PAGE_LOADER',
        });
      }
    },
    [dispatch, schemaName]
  );

  const renderSchemaSelectors = useMemo(() => {
    if (schemaList.length <= 1 || accountsList.length <= 0) {
      return <></>;
    }

    return (
      <>
        <Divider />
        <MenuItem className="list-section-header cur-unset">Switch Accounts</MenuItem>
        <IfComponent isValid={accountsList.length > 0}>
          <TextField
            fullWidth
            placeholder="Search Accounts"
            onChange={(e) => setSearchAccount(e.target.value)}
            value={searchAccount}
            className="search-account-text-field"
            style={{ padding: '4px 8px', fontSize: '12px !important', borderBottom: '1px solid #e0e0e0' }}
            InputProps={{
              startAdornment: <Search />,
            }}
          />
        </IfComponent>
        {(accountsList || [])
          .filter((account) =>
            searchAccount?.length > 0 ? account.cust_name.toLowerCase().includes(searchAccount.toLowerCase()) : true
          )
          .map((account, idx) => (
            <React.Fragment key={idx}>
              {account.listItems ? (
                <CollapsibleListItem
                  {...account}
                  includeParent
                  onClick={(acc) => changeSchema(acc.cust_code)}
                  childKey="cust_child_name"
                  listItemClassName="dropdown-menu"
                  AddOn={({ additionProps }) => (
                    <img src={getLogo(appendHttpsIfNotPresent(additionProps?.domain_url), 64)} />
                  )}
                />
              ) : (
                <ListItem
                  className="dropdown-menu"
                  onClick={() => changeSchema(account.cust_code)}
                  style={{ padding: '4px 8px' }}
                >
                  <img src={getLogo(appendHttpsIfNotPresent(account?.domain_url), 64)} />
                  {account.cust_name}
                  {account.cust_child_name ? ' ' + account.cust_child_name : null}
                </ListItem>
              )}
            </React.Fragment>
          ))}
      </>
    );
  }, [accountsList, changeSchema, schemaList.length, searchAccount]);

  useEffect(() => {
    setDefaultUser(props.defaultUser);
  }, [props.defaultUser, props.getUserType, changeSchema, dispatch]);

  const analyticsEvent = (value) => {
    if (window.analytics) {
      window.analytics.track(`Switched to ${value} Dashboard`);
    } else {
      segmentEventApi(
        `Switched to ${value} Dashboard`,
        {
          option: value,
        },
        'track'
      );
    }
  };

  return (
    <>
      <AppBar className={isEnterpriseUser ? 'app-bar' : 'app-bar-with-q-logo'}>
        {props.SubscriberBanner ? <>{props.SubscriberBanner}</> : null}
        <Toolbar style={{ justifyContent: 'space-between' /*need to change */ }}>
          <div id="layout__div__header_0" style={{ display: 'inline-flex' /*need to change */ }}>
            {props.isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                style={{ zIndex: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {props.isMobile ? (
              <img
                className="q-header-logo"
                src={isEnterpriseUser ? QLogo.src : '/Quattr-Q-logo.png'}
                alt="Quattr logo"
              />
            ) : (
              <img
                className="q-header-logo"
                src={isEnterpriseUser ? QLogo.src : '/Quattr-Q-logo-desktop.svg'}
                alt="Quattr logo"
              />
            )}

            <div className="q-logo-dropdown-container">
              {!isEnterpriseUser && !props.isMobile ? (
                <FormDropDown
                  key={defaultUser}
                  id="opportunities__fromdropdown__opportunity_explorer_27"
                  defaultValue={defaultUser}
                  onChange={(e) => {
                    props?.handleUserToggle(e.target.value);
                    analyticsEvent(e.target.value);
                  }}
                  options={props?.options}
                  className="simple-dropdown-header"
                  style={{
                    margin: 0,
                    padding: 0,
                    height: '28px',
                    background: '#ffff',
                    borderRadius: '4px !important',
                    fontSize: '14px',
                    width: '110px !important',
                  }}
                  fullWidth
                  downArrowChange={'down-arrow-change'}
                  sessionUserType={props?.getUserType}
                />
              ) : null}
            </div>

            {isDatePickerInTopBar && !props.isMobile ? <PageDateRangeSlot variant="top-bar" /> : null}
            {dateRangeHost && filter && filter.filters && showDatePicker && !props.isMobile
              ? createPortal(
                  <DateRangePicker
                    class={'date-picker-theme-color'}
                    isHeader={true}
                    // A comparison reads "vs <dates>" on the screens; the top bar keeps "Compare to :".
                    comparisonPrefix={isDatePickerInTopBar ? undefined : 'vs'}
                    setDateRanges={setDateRanges}
                    onChange={(res, showDatePicker) => updateDatePickerParams(res, showDatePicker)}
                    userSelectedDateRange={userSelectedDateRange}
                    defaultSecondPickerVisible={filter.filters['is_date_comparison'] == 'Yes'}
                    defaultSelected={
                      filter.isTopTrendDetails
                        ? resolveTopTrendPickerSelection(filter.dateRanges.selected, CUSTOM_RANGE)
                        : filter.isPersisitedFilters || isAiVisibilityRoute
                        ? filter.dateRanges.selected
                        : null
                    }
                    key={dateRangekey}
                    isRankingFactor={filter.isRankingFactor}
                    isTopTrendDetails={filter.isTopTrendDetails}
                    defaultDateRange={{
                      startDate1: filter.dateRanges.selected.startDate,
                      endDate1: filter.dateRanges.selected.endDate,
                      startDate2: filter.dateRanges.comparison.startDate,
                      endDate2: filter.dateRanges.comparison.endDate,
                    }}
                  />,
                  dateRangeHost
                )
              : null}
          </div>
          {!props.isMobile && showBreadCrumb && (
            <div className="breadcrumb-wrapper white">
              <Breadcrumbs separator={<ArrowRight />} aria-label="breadcrumb">
                <Typography color="textPrimary">Ad-hoc Analysis</Typography>
                {containsDynamicRoute ? (
                  <Link color="inherit" href={RemoveLastUrlPartOf(pathname, 2)} legacyBehavior>
                    {breadcrumbMeta[pathname.split('/')[3]]}
                  </Link>
                ) : (
                  <Typography color="textPrimary">{breadcrumbMeta[pathname.split('/')[3]]}</Typography>
                )}
                {dynamicRouteTitle && <Typography color="textPrimary">{dynamicRouteTitle}</Typography>}
              </Breadcrumbs>
            </div>
          )}

          <div className="header-customer-and-user-info-wrapper" onClick={handleDropDownclickSchema}>
            <IfComponent isValid={props?.getUserType !== USER_CLASSIFICATION.QWA_TOOLS}>
              {!(showCustomerInfo && schemaList) ? (
                <div className="header-skeleton">
                  <Skeleton variant="rect" className="skeleton-logo" />
                  <Skeleton variant="rect" className="skeleton-name" />
                </div>
              ) : (
                <div className={`header-customer-info-wrapper`}>
                  <IfComponent isValid={showCustomerInfo && schemaList}>
                    <img src={getLogo(appendHttpsIfNotPresent(customerInfo?.[schemaIndex]?.domain_url), 64)} />
                    {customerInfo?.[schemaIndex]?.cust_name && !props?.isMobile && (
                      <p className="p-0 customer-name">{customerInfo?.[schemaIndex]?.cust_name || ''}</p>
                    )}
                    {customerInfo?.[schemaIndex]?.cust_child_name && !props?.isMobile && (
                      <p className="p-0 customer-child-name">
                        {toTitleCase(customerInfo?.[schemaIndex]?.cust_child_name || '')}
                      </p>
                    )}
                    <div className="divider-line"></div>
                  </IfComponent>
                </div>
              )}
            </IfComponent>
            {!userName ? (
              <Skeleton variant="rect" className="skeleton-avatar" />
            ) : (
              <p className="p-0 user-name">{getAvatarInitials(userName)}</p>
            )}
          </div>

          <Popover
            open={openSchema}
            anchorEl={anchorEl2}
            onClose={() => setAnchorEl2(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            className="popup-with-list"
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div className="align-items-Center " style={{ padding: '4px 8px', minWidth: '300px' }}>
              <MenuItem className="user-name cur-unset" style={{ padding: '4px 8px' }}>
                <b>{userName}</b>
              </MenuItem>
              {subscriberMeta?.customer_id && session?.user?.userType === USER_CLASSIFICATION.CONTENT_AI && (
                <ManageSubscriptions
                  buttonType="link"
                  customer_id={subscriberMeta?.customer_id}
                  isMenuItem
                  redirect_url={
                    process.env.NEXT_PUBLIC_HOST_URL !== 'http://localhost:3000'
                      ? `${process.env.NEXT_PUBLIC_HOST_URL}/app/content-ai-home`
                      : 'http://app-predev.quattr.com/app/content-ai-home'
                  }
                />
              )}
              {session?.user?.user_id &&
                session?.user?.userType === USER_CLASSIFICATION.QWA_TOOLS &&
                session?.user?.qwa_tools_subscription_status && (
                  <ManageSubscriptions
                    buttonType="link"
                    customer_id={session?.user?.user_id}
                    isMenuItem
                    redirect_url={
                      process.env.NEXT_PUBLIC_HOST_URL !== 'http://localhost:3000'
                        ? `${process.env.NEXT_PUBLIC_HOST_URL}/app/ai-tools-home`
                        : 'http://app-predev.quattr.com/app/ai-tools-home'
                    }
                    isToolsUser={true}
                    email={session?.user?.email}
                  />
                )}
              <MenuItem onClick={handleLogout} style={{ padding: '4px 8px' }}>
                Sign Out
              </MenuItem>
              {userType == USER_CLASSIFICATION.QWA_TOOLS &&
              props?.isMobile &&
              (props.defaultUser === USER_CLASSIFICATION.QWA_TOOLS ||
                (props.defaultUser === USER_CLASSIFICATION.CONTENT_AI &&
                  [
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_CREATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_REACTIVATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_RESUMED,
                  ].includes(session?.user?.qwa_tools_subscription_status as any))) ? (
                <div>
                  <Divider />
                  <div onClick={() => setAnchorEl2(null)}>
                    <CreditsComponent />
                  </div>
                </div>
              ) : null}
            </div>
            {renderSchemaSelectors}
          </Popover>
        </Toolbar>
      </AppBar>
    </>
  );
}
